import { Stack, Typography, useTheme } from "@mui/material";
import { CalendarIcon } from "components/icons";

export const CalendarHeader = () => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="8px"
      sx={{
        p: "12px 16px",
        borderBottom: `1px solid ${theme.palette.neutral["010"]}`,
      }}
    >
      <CalendarIcon
        sx={{ fontSize: "20px", color: theme.palette.lightBg.high }}
      />
      <Typography
        variant="subtitle1"
        sx={{ color: theme.palette.lightBg.high }}
      >
        Calendar
      </Typography>
    </Stack>
  );
};
